import React, { Fragment, useState, useEffect } from "react";
import PropTypes from "prop-types";

import { connect } from "react-redux";
import { getCompanies, getCompanyEmployees } from "../actions/companyActions";
import {
  getCompaniesOfEmployee,
  getHourRegistrationOfEmployee,
} from "../actions/employeeActions";
import { getHourRegistrationOfCompany } from "../actions/companyActions";
import { getHourRegistrationOfCompanyEmployee } from "../actions/companyEmployeeActions";
import { getCollectiveLabourAgreements } from "../actions/claActions";
import calculateAllowanceForShift from "../helpers/calculateAllowanceForShift";
import mergeNumericObjects from "../helpers/mergeNumericObjects";

import Form from "./forms/Form";
import {
  Grid,
  InputLabel,
  Select,
  MenuItem,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Button,
} from "@material-ui/core";

import FullScreenLoader from "../components/FullScreenLoader";

import { KeyboardDatePicker } from "@material-ui/pickers";

import TimeStringHelper from "../helpers/TimeStringHelper";

import exportTableToExcel from "../helpers/export-table-to-excel";
// import ReactHTMLTableToExcel from "react-html-table-to-excel";
import formatPrice from "../utils/format-price";
import { UserType } from "../types/enums";
import { EmploymentType } from "../types/enums";
import isEmployee from "../utils/is-employee";
import moment from "moment";
import { GetApp } from "@material-ui/icons";

let credentials = JSON.parse(localStorage.getItem("credentials"));

const HourRegistration = (props) => {
  const [isFetching, setIsFetching] = useState(false);

  const [company, setCompany] = useState("");
  const [employee, setEmployee] = useState("");

  const [beginDate, setBeginDate] = useState(moment());
  const [endDate, setEndDate] = useState(moment());

  const [clas, setClas] = useState([]);

  const [optionCompanies, setOptionCompanies] = useState([]);
  const [optionEmployees, setOptionEmployees] = useState([]);
  const [hourRegistration, setHourRegistration] = useState([]);

  useEffect(() => refreshData(), []);

  const refreshData = async () => {
    try {
      setIsFetching(true);

      const clas = await getCollectiveLabourAgreements();
      setClas(clas);

      if (credentials.user.type === UserType.PERSON) {
        const companies = await props.getCompanies();
        setOptionCompanies(companies);
      }

      if (credentials.user.type === UserType.COMPANY) {
        const employees = await props.getCompanyEmployees(
          credentials.user.email,
        );

        setCompany(credentials.user.email);
        setOptionEmployees(employees);
      }

      if (credentials.user.type === UserType.EMPLOYEE) {
        if (credentials.user.isSeniorEmployee) {
          const companies = await props.getCompaniesOfEmployee(
            credentials.user.email,
            true,
          );

          setOptionCompanies(companies);
        } else {
          setEmployee(credentials.user.email);
        }
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsFetching(false);
    }
  };

  const handleCompanyChange = async (e) => {
    setCompany(e.target.value);
    const employees = await props.getCompanyEmployees(e.target.value);
    setOptionEmployees(employees);
  };

  const searchHourRegistration = async () => {
    try {
      setIsFetching(true);
      setHourRegistration([]);

      if (company !== "" && employee !== "") {
        const hourRegistration = await getHourRegistrationOfCompanyEmployee(
          company,
          employee,
          beginDate,
          endDate,
        );
        setHourRegistration(hourRegistration);
      } else if (company !== "" && employee === "") {
        const hourRegistration = await getHourRegistrationOfCompany(
          company,
          beginDate,
          endDate,
        );
        setHourRegistration(hourRegistration);
      } else if (company === "" && employee !== "") {
        const hourRegistration = await getHourRegistrationOfEmployee(
          employee,
          beginDate,
          endDate,
        );
        setHourRegistration(hourRegistration);
      }
    } finally {
      setIsFetching(false);
    }
  };

  let totalNumberOfShifts = 0,
    totalBreakTimeSubstraction = 0,
    totalNumberOfMinutes = 0,
    totalPrice = 0.0,
    totalAllowance = 0.0,
    totalAllowances = {},
    totalCommuteAllowance = 0.0,
    totalDistance = 0;

  return (
    <Fragment>
      <Form>
        <Grid container spacing={3}>
          {(credentials.user.isAdmin || credentials.user.isSeniorEmployee) && (
            <Grid item xs={12} sm={6}>
              <Fragment>
                <InputLabel htmlFor="company">Bedrijf *</InputLabel>
                <Select
                  id="company"
                  name="company"
                  value={company}
                  onChange={handleCompanyChange}
                  fullWidth
                >
                  {optionCompanies.map((c) => (
                    <MenuItem
                      key={c.email}
                      value={c.email}
                      style={{
                        fontWeight: company != c.email ? "normal" : "500",
                      }}
                    >
                      {c.name}
                    </MenuItem>
                  ))}
                </Select>
              </Fragment>
            </Grid>
          )}

          {(credentials.user.type !== UserType.EMPLOYEE ||
            credentials.user.isSeniorEmployee) && (
            <Grid item xs={12} sm={credentials.user.type == "COMPANY" ? 12 : 6}>
              <InputLabel htmlFor="employee">Medewerker *</InputLabel>
              <Select
                id="employee"
                name="employee"
                value={employee}
                onChange={(e) => setEmployee(e.target.value)}
                fullWidth
              >
                <MenuItem value="">
                  <em>Geen</em>
                </MenuItem>
                {optionEmployees.map((e) => (
                  <MenuItem
                    key={e.email}
                    value={e.email}
                    style={{
                      fontWeight: employee !== e.email ? "normal" : "500",
                    }}
                  >
                    {e.firstName} {e.lastName} ({e.email})
                  </MenuItem>
                ))}
              </Select>
            </Grid>
          )}

          <Grid item xs={12} sm={6}>
            <KeyboardDatePicker
              clearable
              mask="__-__-____"
              id="beginDate"
              name="beginDate"
              label="Begindatum *"
              value={beginDate}
              format={"L"}
              onChange={(m) => setBeginDate(m)}
              fullWidth
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <KeyboardDatePicker
              clearable
              mask="__-__-____"
              id="endDate"
              name="endDate"
              label="Einddatum *"
              value={endDate}
              format={"L"}
              onChange={(m) => setEndDate(m)}
              fullWidth
            />
          </Grid>

          <Grid item xs={12} sm={12} onClick={searchHourRegistration}>
            <Button variant="contained" color="primary">
              Zoek
            </Button>
          </Grid>
        </Grid>
      </Form>

      <div style={{ overflowX: "auto" }}>
        <Table id="hour-registration-table">
          <TableHead>
            <TableRow>
              <TableCell>Datum</TableCell>
              <TableCell>Medewerker</TableCell>
              <TableCell>Aanvang</TableCell>
              <TableCell>Einde</TableCell>
              <TableCell>Pauze</TableCell>
              <TableCell>Uren</TableCell>

              {(credentials.user.type !== UserType.EMPLOYEE ||
                credentials.user.isSeniorEmployee) && (
                <Fragment>
                  <TableCell>Uurtarief (excl. BTW)</TableCell>
                  <TableCell>Prijs (excl. BTW)</TableCell>
                  <TableCell>Toeslag</TableCell>
                </Fragment>
              )}

              <TableCell>Reisvergoeding</TableCell>
              <TableCell>Km</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {hourRegistration.map((project, i) => {
              let subTotalNumberOfShifts = 0,
                subTotalBreakTimeSubstraction = 0,
                subTotalNumberOfMinutes = 0,
                subTotalPrice = 0.0,
                subTotalAllowance = 0.0,
                subTotalAllowances = {},
                subTotalCommuteAllowance = 0.0,
                subTotalDistance = 0;

              if (!project.shifts.some((s) => s.employees.length)) return;

              return (
                <Fragment key={i}>
                  <TableRow key={`project_${i}`}>
                    <TableCell
                      colSpan={
                        credentials.user.type !== UserType.EMPLOYEE ||
                        credentials.user.isSeniorEmployee
                          ? 11
                          : 9
                      }
                    >
                      <b>{project.name}</b>
                    </TableCell>
                  </TableRow>

                  {project.shifts.map((shift) => {
                    const { priceForDelivering } = shift;

                    return shift.employees.map((employee, i) => {
                      let startDateTime =
                          employee.CompanyEmployeeShift.startDateTime ||
                          shift.beginDatetime,
                        endDateTime =
                          employee.CompanyEmployeeShift.endDateTime ||
                          shift.endDatetime,
                        breakTimeSubstraction =
                          typeof employee.CompanyEmployeeShift
                            .breakTimeSubstraction === "number"
                            ? employee.CompanyEmployeeShift
                                .breakTimeSubstraction
                            : shift.breakTimeSubstraction,
                        workedMinutes = parseInt(
                          Math.abs(
                            moment(endDateTime).diff(moment(startDateTime)),
                          ) /
                            (60 * 1000) -
                            breakTimeSubstraction,
                        );

                      let price =
                        parseFloat(priceForDelivering) * (workedMinutes / 60);

                      const cla =
                        (employee.cla
                          ? clas.find((cla) => cla.id === employee.cla.id)
                          : {}) || {};
                      const { allowance = 0, ...allowancePercentages } =
                        calculateAllowanceForShift(
                          {
                            startDateTime,
                            endDateTime,
                            price: priceForDelivering,
                          },
                          {
                            allowances: cla.allowances,
                            timezone: "Europe/Amsterdam",
                          },
                        );

                      subTotalAllowances = mergeNumericObjects(
                        allowancePercentages,
                        subTotalAllowances,
                      );
                      totalAllowances = mergeNumericObjects(
                        allowancePercentages,
                        totalAllowances,
                      );

                      subTotalNumberOfShifts++;
                      subTotalBreakTimeSubstraction += breakTimeSubstraction;
                      subTotalNumberOfMinutes += workedMinutes;
                      subTotalPrice += price;
                      subTotalAllowance += allowance;
                      subTotalCommuteAllowance +=
                        isEmployee &&
                        employee.employmentType === EmploymentType.CONTRACTED
                          ? 0
                          : employee.CompanyEmployeeShift.commuteAllowance;
                      subTotalDistance += parseInt(
                        employee.CompanyEmployeeShift.distance,
                      );

                      totalNumberOfShifts++;
                      totalBreakTimeSubstraction += breakTimeSubstraction;
                      totalNumberOfMinutes += workedMinutes;
                      totalPrice += price;
                      totalAllowance += allowance;
                      totalCommuteAllowance +=
                        isEmployee &&
                        employee.employmentType === EmploymentType.CONTRACTED
                          ? 0
                          : employee.CompanyEmployeeShift.commuteAllowance;
                      totalDistance += parseInt(
                        employee.CompanyEmployeeShift.distance,
                      );

                      return (
                        <TableRow key={`shift_${shift.id}_${i}`}>
                          <TableCell>
                            {moment(
                              employee.CompanyEmployeeShift.startDateTime ||
                                shift.beginDatetime,
                            ).format("ddd, MMMM DD, YYYY")}
                          </TableCell>
                          <TableCell>
                            {employee.employee.firstName}{" "}
                            {employee.employee.lastName}
                          </TableCell>
                          <TableCell>
                            {moment(startDateTime).format("HH:mm")}
                          </TableCell>
                          <TableCell>
                            {moment(endDateTime).format("HH:mm")}
                          </TableCell>
                          <TableCell>
                            {breakTimeSubstraction > 0
                              ? `${breakTimeSubstraction} min`
                              : "-"}
                          </TableCell>
                          <TableCell>
                            {TimeStringHelper.parseMinutesToString(
                              workedMinutes,
                            )}
                          </TableCell>

                          {(credentials.user.type !== UserType.EMPLOYEE ||
                            credentials.user.isSeniorEmployee) && (
                            <Fragment>
                              <TableCell>
                                {formatPrice(shift.priceForDelivering)}
                              </TableCell>
                              <TableCell>{formatPrice(price)}</TableCell>
                              <TableCell>
                                {Object.keys(allowancePercentages)
                                  .map((percentage) => {
                                    const minutes =
                                      allowancePercentages[percentage];
                                    const time =
                                      TimeStringHelper.parseMinutesToString(
                                        minutes,
                                      );
                                    return `${time} x ${percentage}%`;
                                  })
                                  .join(" en ")}
                              </TableCell>
                            </Fragment>
                          )}

                          <TableCell>
                            {formatPrice(
                              isEmployee &&
                                employee.employmentType ===
                                  EmploymentType.CONTRACTED
                                ? 0
                                : employee.CompanyEmployeeShift
                                    .commuteAllowance,
                            )}
                          </TableCell>

                          <TableCell>
                            {parseInt(employee.CompanyEmployeeShift.distance)}{" "}
                            km
                          </TableCell>
                        </TableRow>
                      );
                    });
                  })}

                  <TableRow key={`subtotals_${i}`}>
                    <TableCell colSpan={2}>
                      <b>Subtotalen</b>
                    </TableCell>
                    <TableCell colSpan={2}>
                      <b>
                        {subTotalNumberOfShifts} dienst
                        {subTotalNumberOfShifts > 1 ? "en" : null}
                      </b>
                    </TableCell>
                    <TableCell>
                      <b>
                        {subTotalBreakTimeSubstraction > 0
                          ? `${subTotalBreakTimeSubstraction} min`
                          : "-"}
                      </b>
                    </TableCell>
                    <TableCell>
                      <b>
                        {TimeStringHelper.parseMinutesToString(
                          subTotalNumberOfMinutes,
                        )}
                      </b>
                    </TableCell>

                    {(credentials.user.type !== UserType.EMPLOYEE ||
                      credentials.user.isSeniorEmployee) && (
                      <Fragment>
                        <TableCell></TableCell>
                        <TableCell>
                          <b>{formatPrice(subTotalPrice)}</b>
                        </TableCell>
                        <TableCell>
                          <b>{formatPrice(subTotalAllowance)}</b>
                        </TableCell>
                      </Fragment>
                    )}

                    <TableCell>
                      <b>{formatPrice(subTotalCommuteAllowance)}</b>
                    </TableCell>

                    <TableCell>
                      <b>{subTotalDistance} km</b>
                    </TableCell>
                  </TableRow>

                  {Object.keys(subTotalAllowances).map((subTotalAllowance) => (
                    <TableRow
                      key={`subtotals_allowance_${subTotalAllowance}_${i}`}
                    >
                      <TableCell colSpan={2}> </TableCell>
                      <TableCell colSpan={2}>
                        Toeslag {subTotalAllowance}%
                      </TableCell>
                      <TableCell>-</TableCell>
                      <TableCell>
                        {TimeStringHelper.parseMinutesToString(
                          subTotalAllowances[subTotalAllowance],
                        )}
                      </TableCell>
                      <TableCell colSpan={4}></TableCell>
                      <TableCell colSpan={4}></TableCell>
                    </TableRow>
                  ))}

                  <TableRow key={`empty_row_${i}`}>
                    <TableCell colSpan={10}></TableCell>
                  </TableRow>
                </Fragment>
              );
            })}

            <TableRow key={`totals`}>
              <TableCell colSpan={2}>
                <b>Totalen</b>
              </TableCell>
              <TableCell colSpan={2}>
                <b>
                  {totalNumberOfShifts} dienst
                  {totalNumberOfShifts > 1 ? "en" : null}
                </b>
              </TableCell>
              <TableCell>
                <b>
                  {totalBreakTimeSubstraction > 0
                    ? `${totalBreakTimeSubstraction} min`
                    : "-"}
                </b>
              </TableCell>
              <TableCell>
                <b>
                  {TimeStringHelper.parseMinutesToString(totalNumberOfMinutes)}
                </b>
              </TableCell>

              {(credentials.user.type !== UserType.EMPLOYEE ||
                credentials.user.isSeniorEmployee) && (
                <Fragment>
                  <TableCell>
                    <b>Totaal excl. BTW</b>
                  </TableCell>
                  <TableCell>
                    <b>{formatPrice(totalPrice)}</b>
                  </TableCell>
                  <TableCell></TableCell>
                </Fragment>
              )}

              <TableCell>
                <b>{formatPrice(totalCommuteAllowance)}</b>
              </TableCell>

              <TableCell>
                <b>{totalDistance} km</b>
              </TableCell>
            </TableRow>

            {Object.keys(totalAllowances).map((totalAllowance) => (
              <TableRow key={`totals_allowance_${totalAllowance}`}>
                <TableCell colSpan={2}> </TableCell>
                <TableCell colSpan={2}>Toeslag {totalAllowance}%</TableCell>
                <TableCell>-</TableCell>
                <TableCell>
                  {TimeStringHelper.parseMinutesToString(
                    totalAllowances[totalAllowance],
                  )}
                </TableCell>
                <TableCell colSpan={4}></TableCell>
              </TableRow>
            ))}

            {(credentials.user.type !== UserType.EMPLOYEE ||
              credentials.user.isSeniorEmployee) && (
              <Fragment>
                <TableRow key={`allowance`}>
                  <TableCell colSpan={2}></TableCell>
                  <TableCell colSpan={2}></TableCell>
                  <TableCell></TableCell>
                  <TableCell></TableCell>
                  <TableCell>
                    <b>Totaal toeslag</b>
                  </TableCell>
                  <TableCell>
                    <b>{formatPrice(totalAllowance)}</b>
                  </TableCell>
                  <TableCell></TableCell>
                  <TableCell></TableCell>
                  <TableCell></TableCell>
                </TableRow>

                <TableRow key={`tax`}>
                  <TableCell colSpan={2}></TableCell>
                  <TableCell colSpan={2}></TableCell>
                  <TableCell></TableCell>
                  <TableCell></TableCell>
                  <TableCell>
                    <b>BTW (21%)</b>
                  </TableCell>
                  <TableCell>
                    <b>{formatPrice((totalPrice + totalAllowance) * 0.21)}</b>
                  </TableCell>
                  <TableCell></TableCell>
                  <TableCell></TableCell>
                  <TableCell></TableCell>
                </TableRow>

                <TableRow key={`total_incl_tax`}>
                  <TableCell colSpan={2}></TableCell>
                  <TableCell colSpan={2}></TableCell>
                  <TableCell></TableCell>
                  <TableCell></TableCell>
                  <TableCell>
                    <b>Totaal incl. BTW</b>
                  </TableCell>
                  <TableCell>
                    <b>{formatPrice((totalPrice + totalAllowance) * 1.21)}</b>
                  </TableCell>
                  <TableCell></TableCell>
                  <TableCell></TableCell>
                  <TableCell></TableCell>
                </TableRow>
              </Fragment>
            )}
          </TableBody>
        </Table>
      </div>

      {isFetching && <FullScreenLoader />}

      <br />

      <Button
        variant="outlined"
        color="primary"
        startIcon={<GetApp />}
        onClick={() => exportTableToExcel("hour-registration-table")}
      >
        Exporteer naar Excel
      </Button>
    </Fragment>
  );
};

HourRegistration.propTypes = {
  getCompanies: PropTypes.func.isRequired,
  getCompanyEmployees: PropTypes.func.isRequired,
  getCompaniesOfEmployee: PropTypes.func.isRequired,
};

export default connect(null, {
  getCompanies,
  getCompanyEmployees,
  getCompaniesOfEmployee,
})(HourRegistration);



// WEBPACK FOOTER //
// ./src/components/HourRegistration.js